var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacePink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.158,
    height: 24.511,
    viewBox: "0 0 17.158 24.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-place",
    "data-name": "Icon material-place",
    d: "M16.079,3A8.572,8.572,0,0,0,7.5,11.579c0,6.434,8.579,15.932,8.579,15.932s8.579-9.5,8.579-15.932A8.572,8.572,0,0,0,16.079,3Zm0,11.643a3.064,3.064,0,1,1,3.064-3.064A3.065,3.065,0,0,1,16.079,14.643Z",
    transform: "translate(-7.5 -3)",
    fill: "#eb7c7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacePink);
export default __webpack_public_path__ + "static/media/place_pink.b99e41efe7050291cac781cdd84798ae.svg";
export { ForwardRef as ReactComponent };